<template>
  <div :id="$id('button')" ref='buttonContainer'>
    <make-booking
      ref="makeBooking"
      :location="location"
      :saleFrom="saleFrom"
      :locationDiscount="locationDiscount"/>

    <button v-if="$deploymentIs('cryptology')" :class="'btn btn-lg btn-' + virtualGame.nickname" @click="purchaseVirtualGame(virtualGame)">
      BUY FOR {{ virtualGame.price | money }}
    </button>
    <button v-else :class="'btn-' + $deploymentCurrent" @click="purchaseVirtualGame(virtualGame)">
      BUY FOR {{ virtualGame.price | money }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    virtualGame: {
      type: Object,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    saleFrom: {
      type: String,
      default: 'G',
    },
    locationDiscount: {
      type: Object,
    },
  },

  data() {
    return {

    };
  },

  computed: {

  },

  watch: {

  },

  methods: {
    purchaseVirtualGame(virtualGame) {
      this.$refs.makeBooking.startVirtualBooking(virtualGame);
    },

  },
}
</script>
